<template>
  <div class="contact">
    <div class="about-txt about-txt1">
      <div class="left">
        <h2 class="m-about-title">{{ $t('contact.aboutUs') }}</h2>
        <div class="article">
          <p>{{ $t('contact.aboutText1') }}
          </p>
          <p><br></p>
          <p>{{ $t('contact.aboutText2') }}
          </p>
        </div>
      </div>
      <img src="../assets/images/about10.jpg" alt="黎明软件科技">
    </div>
    <div class="a-corporate box">
      <div class="a-t1">
        {{ $t('contact.corporate') }}
      </div>
      <div class="a-corporate-list">
        <div class="a-corporate-list-dv a-m1">
          <div>{{ $t('contact.vision') }}</div>
          <div>
            {{ $t('contact.visionText') }}
          </div>
        </div>
        <div class="a-corporate-list-dv a-m2">
          <div>{{ $t('contact.mission') }}</div>
          <div>
            {{ $t('contact.missionText') }}
          </div>
        </div>
        <div class="a-corporate-list-dv a-m3">
          <div>{{ $t('contact.values') }}</div>
          <div>{{ $t('contact.valuesText') }}</div>
        </div>
      </div>
    </div>
    <h2 style="font-size: 36px;text-align: center;margin-bottom: 50px;">{{ $t('contact.contactUs') }}</h2>
    <div class="mapText" style="margin-bottom: 50px;">
      <div id="map" style="width: 800px; height: 500px;"></div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'Contact',
  data() {
    return {

    }
  },
  mounted() {
    this.initMap()
    // 监听语言切换事件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate()
    })
  },
  beforeDestroy() {
    this.$root.$off('language-changed')
  },
  methods: {
    initMap() {
      var map = new BMapGL.Map("map");          // 创建地图实例 
      var point = new BMapGL.Point(113.640184, 34.685708);  // 创建点坐标 
      map.centerAndZoom(point, 15);
      map.enableScrollWheelZoom(true);
    }
  }
}
</script>

<style scoped>
.contact {
  width: 1200px;
  margin: 0 auto;
}
  .mapText{
    display: flex;
  }
.about-txt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.m-about-title {
  font-size: 36px;
  line-height: 48px;
  font-weight: 700;
  color: var(--text-primary);
  text-align: left;
}

.about-txt .article {
  padding: 40px 0;
  font-size: 16px;
  line-height: 30px;
  color: var(--text-secondary);
  text-align: justify;
  text-justify: inter-ideograph
}

.about-txt1 {
  margin: 50px 0;
}

.about-txt1 .left {
  flex: 1;
  margin-right: 80px;
}



.a-corporate {
  text-align: center;
  margin: 50px auto
}

.a-corporate-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 44px
}

.a-corporate-list-dv {
  width: 33%;
  height: 257px;
  padding: 58px 78px;
  box-sizing: border-box;
  color: #fff
}

.a-corporate-list-dv div:first-child {
  font-size: 25px;
  margin-bottom: 21px
}

.a-corporate-list-dv div:last-child {
  font-size: 16px
}

.a-m1 {
  background: url(../assets/images/culture1.png) no-repeat top
}

.a-m2 {
  background: url(../assets/images/culture2.png) no-repeat top
}

.a-m3 {
  background: url(../assets/images/culture3.png) no-repeat top
}

.a-t1 {
  color: var(--text-primary);
  font-size: 36px
}

.a-corporate-list-dv:hover,
.a-understand-bot img:hover {
  transform: scale(1.1);
  transition: all .5s linear
}
</style>